(() => {
  function refresh() {
    const quote = document.querySelector('.li-product-quote-action');
    if (quote) {
      const form = document.querySelector('product-form form');
      const id = form?.querySelector('[name="id"]')?.value;
      const quantity = document.querySelector('input[name="quantity"]');
      const variant = JSON.parse(quote.dataset.variants || '[]').find(v => String(v.id) === String(id));
      if (variant) {
        const params = new URLSearchParams({ product: quote.dataset.productTitle, sku: variant.sku || '', variant: variant.title, quantity: quantity?.value || '1' });
        const unit = window.LuksQuoteHelpers?.sellingUnit(variant.sku, variant.title, quote.dataset.each, quote.dataset.pack);
        if (unit) params.set('unit', unit);
        if (variant.sku === '5481-BL') { params.set('unit', quote.dataset.each); if (quantity) { quantity.min='100';quantity.step='100'; } }
        quote.href='/pages/contact-us?'+params.toString();
      }
    }
  }
  document.addEventListener('change', refresh);
  document.addEventListener('input', refresh);
  document.addEventListener('click', event => { if(event.target.closest('.li-product-quote-action')) refresh(); }, true);
  document.addEventListener('shopify:section:load', refresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, refresh);
    let cartRequest = 0;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      const request = ++cartRequest;
      const section = document.querySelector('[data-cart-quote]');
      const link = section?.querySelector('[data-cart-quote-link]');
      if (section) section.dataset.refreshPending = 'true';
      if (link) { link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); link.setAttribute('aria-busy', 'true'); }
      fetch((window.Shopify?.routes?.root || '/')+'cart.js',{cache:'no-store'}).then(r=>{ if(!r.ok) throw new Error('cart'); return r.json(); }).then(cart=>{
        if (request !== cartRequest) return;
        document.querySelectorAll('.li-nav a[href="/cart"]').forEach(a=>a.textContent='Cart ('+cart.item_count+')');
        const el=document.querySelector('[data-cart-quote]');
        if(el) { el.dataset.items=JSON.stringify(cart.items); el.dataset.refreshPending='false'; el.querySelector('[data-cart-quote-link]')?.removeAttribute('aria-busy'); }
        document.dispatchEvent(new CustomEvent('luks:cart-refreshed'));
      }).catch(()=>{
        if (request !== cartRequest) return;
        const el=document.querySelector('[data-cart-quote]');
        if(el) { el.querySelector('[data-cart-quote-link]')?.removeAttribute('aria-busy'); el.querySelector('[data-cart-quote-status]').textContent=el.dataset.refreshError; }
      });
    });
  }
  refresh();
})();

